/* ============================================================
   PLAN CONFIGURATEUR v2 — JavaScript
   assets/plan-configurator.js
   
   Fonctionnement :
   1. L'utilisateur choisit 7 / 14 / 28 jours
   2. Les quotas se configurent automatiquement
   3. Le prix total s'affiche dans la sticky bar une fois terminé
   4. Le shaker est ajouté gratuitement (price_set à 0 via properties)
   5. Chaque produit individuel est ajouté pour la logistique
   ============================================================ */

(function () {
  'use strict';

  /* ── QUOTAS PAR PROGRAMME ─────────────────────────────────── */
  const PROGRAMS = {
    7:  { pd: 6,  sale: 4,  encas: 7,  label: 'Programme 7 jours',  goal: 'jusqu\'à −3 kg' },
    14: { pd: 12, sale: 7,  encas: 14, label: 'Programme 14 jours', goal: 'jusqu\'à −5 kg' },
    28: { pd: 24, sale: 14, encas: 28, label: 'Programme 28 jours', goal: 'jusqu\'à −9 kg' },
  };

  /* ── ÉTAT GLOBAL ──────────────────────────────────────────── */
  let currentProgram = null;   // 7 | 14 | 28
  let quotas = {};             // { pd, sale, encas }
  const state = {};            // { variantId: { qty, category, title, price } }

  /* ── INIT ─────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('plan-configurator');
    if (!root) return;

    const SHAKER_VARIANT  = root.dataset.shakerVariant;
    const SHAKER_TITLE    = root.dataset.shakerTitle || 'Shaker 250ml';
    const GUIDE_VARIANT   = root.dataset.guideVariant;
    const GUIDE_TITLE     = root.dataset.guideTitle || 'Guide du programme';
    const TXT_MAX         = root.dataset.txtMax || 'Maximum atteint pour cette catégorie';
    const TXT_ADDED       = root.dataset.txtAdded || '✓ Programme ajouté au panier !';
    const TXT_UNAVAILABLE = root.dataset.txtUnavailable || 'Un produit est indisponible. Vérifiez votre sélection.';

    /* ── ÉTAPE 0 : choix du programme ───────────────────────── */
    root.querySelectorAll('.plan-programs__card').forEach(card => {
      const selectProgram = () => {
        const days = parseInt(card.dataset.program, 10);
        chooseProgram(days);
      };
      card.addEventListener('click', selectProgram);
      card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectProgram(); } });
    });

    /* ── BOUTON RETOUR ──────────────────────────────────────── */
    document.getElementById('pc-back').addEventListener('click', () => {
      goToStep('choice');
      resetState();
    });

    const isMobile = () => window.innerWidth <= 600;

    /* ── CLIC IMAGE/NOM SUR MOBILE → +1 au lieu d'ouvrir l'onglet ── */
    root.addEventListener('click', e => {
      if (!isMobile()) return;
      const link = e.target.closest('.pc-card__link');
      if (!link) return;
      e.preventDefault();
      const btnPlus = link.closest('.pc-card')?.querySelector('.pc-card__btn--plus');
      if (btnPlus && !btnPlus.disabled) btnPlus.click();
    }, true); // capture phase pour intercepter avant le navigateur

    /* ── CLICS +/– ──────────────────────────────────────────── */
    root.addEventListener('click', e => {
      const plus  = e.target.closest('.pc-card__btn--plus');
      const minus = e.target.closest('.pc-card__btn--minus');
      if (!plus && !minus) return;

      const card  = (plus || minus).closest('.pc-card');
      const vid   = card.dataset.variantId;
      const cat   = card.dataset.category;

      /* Bloquer les produits en rupture (vid vide ou data-sold-out) */
      if (!vid || card.dataset.soldOut === 'true') return;

      let qty     = state[vid]?.qty || 0;

      if (plus) {
        if (countCat(cat) >= quotas[cat]) {
          showToast(TXT_MAX, 'err');
          return;
        }
        qty++;
      } else {
        if (qty <= 0) return;
        qty--;
      }

      if (qty === 0) {
        delete state[vid];
      } else {
        state[vid] = { qty, category: cat, title: card.dataset.title, price: parseInt(card.dataset.price, 10) };
      }

      updateUI();

      /* ── AUTO-SCROLL MOBILE : catégorie complète → bloc suivant ── */
      if (isMobile() && plus) {
        const catOrder = ['pd', 'sale', 'encas'];
        const idx      = catOrder.indexOf(cat);
        const justDone = countCat(cat) >= quotas[cat];

        if (justDone && idx < catOrder.length - 1) {
          const nextBloc = document.getElementById('bloc-' + catOrder[idx + 1]);
          if (nextBloc) {
            setTimeout(() => {
              const top = nextBloc.getBoundingClientRect().top + window.scrollY - 72;
              window.scrollTo({ top, behavior: 'smooth' });
            }, 280);
          }
        }
      }
    });

    /* ── AJOUT AU PANIER ────────────────────────────────────── */
    document.getElementById('pc-add-to-cart').addEventListener('click', async () => {
      if (!allComplete()) return;

      const cta = document.getElementById('pc-add-to-cart');
      cta.classList.add('is-loading');
      cta.disabled = true;

      const prog      = PROGRAMS[currentProgram];
      const catLabels = { pd: 'Petit-déj', sale: 'Repas salés', encas: 'Encas' };

      /* Résumé par catégorie pour les properties du panier */
      const summary = {};
      Object.values(state).forEach(item => {
        const k = catLabels[item.category];
        if (!summary[k]) summary[k] = [];
        summary[k].push(`${item.title} ×${item.qty}`);
      });

      const items = [];

      /* Chaque produit individuel (logistique) */
      Object.entries(state).forEach(([vid, item]) => {
        const variantId = parseInt(vid, 10);
        if (!variantId || isNaN(variantId)) return; // sécurité
        items.push({
          id:       variantId,
          quantity: item.qty,
          properties: {
            '_Programme': prog.label,
            '_Catégorie': catLabels[item.category],
            '_Logistique': 'oui',
          },
        });
      });

      /* Shaker offert — variant ID résolu directement en Liquid */
      if (SHAKER_VARIANT && SHAKER_VARIANT.trim() !== '' && SHAKER_VARIANT !== '0') {
        const shakerId = parseInt(SHAKER_VARIANT.trim(), 10);
        if (shakerId && !isNaN(shakerId)) {
          items.push({
            id:       shakerId,
            quantity: 1,
            properties: {
              '_Programme': prog.label,
              '_Offert':    'oui — shaker inclus avec le programme',
              '_Logistique': 'oui',
            },
          });
          console.log('[PlanConfig] Shaker ajouté, variant ID :', shakerId);
        }
      }

      /* Guide offert — même principe */
      if (GUIDE_VARIANT && GUIDE_VARIANT.trim() !== '' && GUIDE_VARIANT !== '0') {
        const guideId = parseInt(GUIDE_VARIANT.trim(), 10);
        if (guideId && !isNaN(guideId)) {
          items.push({
            id:       guideId,
            quantity: 1,
            properties: {
              '_Programme': prog.label,
              '_Offert':    'oui — guide inclus avec le programme',
              '_Logistique': 'oui',
            },
          });
          console.log('[PlanConfig] Guide ajouté, variant ID :', guideId);
        }
      }

      if (items.length === 0) {
        showToast('Aucun produit valide à ajouter.', 'err');
        cta.classList.remove('is-loading');
        cta.disabled = false;
        return;
      }

      /* Log debug (visible dans la console navigateur) */
      console.log('[PlanConfig] Items envoyés au panier :', items);

      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items }),
        });

        const resData = await res.json().catch(() => ({}));

        if (!res.ok) {
          /* Shopify 422 : description contient souvent le titre du produit problématique */
          const errMsg = resData.description || resData.message || `Erreur HTTP ${res.status}`;
          console.error('[PlanConfig] Réponse Shopify :', resData);
          throw new Error(errMsg);
        }

        showToast(TXT_ADDED, 'ok');
        refreshCartCount();
        setTimeout(() => { window.location.href = '/cart'; }, 1300);

      } catch (err) {
        console.error('[PlanConfig] Erreur panier :', err);
        /* Message d'erreur plus lisible pour le client */
        const msg = err.message.includes('422') || err.message.includes('HTTP')
          ? TXT_UNAVAILABLE
          : err.message;
        showToast('⚠️ ' + msg, 'err');
        cta.classList.remove('is-loading');
        cta.disabled = false;
      }
    });

    /* ── AFFICHER LA STICKY BAR au scroll dès step-config ───── */
    const sticky = document.getElementById('plan-sticky');
    const observer = new IntersectionObserver(entries => {
      // La sticky s'affiche dès qu'on est dans l'étape config
      const configStep = document.getElementById('step-config');
      if (!configStep || configStep.hidden) return;
      sticky.classList.toggle('is-visible', true);
    }, { threshold: 0 });
    observer.observe(document.getElementById('step-config') || document.body);

  }); // end DOMContentLoaded

  /* ── CHOISIR UN PROGRAMME ─────────────────────────────────── */
  function chooseProgram (days) {
    currentProgram = days;
    quotas = { ...PROGRAMS[days] };

    /* Mettre à jour les quotas affichés dans le DOM */
    ['pd', 'sale', 'encas'].forEach(cat => {
      const el = document.getElementById('quota-' + cat);
      if (el) el.textContent = quotas[cat];
      const qEl = document.getElementById('q-' + cat);
      if (qEl) qEl.textContent = quotas[cat];
    });

    /* Total */
    const total = quotas.pd + quotas.sale + quotas.encas;
    const stTotal = document.getElementById('sticky-total');
    if (stTotal) stTotal.textContent = total;

    /* Badge programme dans le header configurateur */
    const badge = document.getElementById('pc-program-badge');
    if (badge) {
      badge.textContent = `${days} jours — ${PROGRAMS[days].goal}`;
    }

    resetState();
    goToStep('config');

    /* Afficher la sticky bar */
    const sticky = document.getElementById('plan-sticky');
    if (sticky) sticky.classList.add('is-visible');

    updateUI();
  }

  /* ── NAVIGATION ENTRE ÉTAPES ──────────────────────────────── */
  function goToStep (name) {
    document.getElementById('step-choice').hidden = (name !== 'choice');
    document.getElementById('step-config').hidden = (name !== 'config');

    const sticky = document.getElementById('plan-sticky');
    if (sticky) sticky.classList.toggle('is-visible', name === 'config');

    if (name === 'choice') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /* ── RESET ÉTAT ───────────────────────────────────────────── */
  function resetState () {
    Object.keys(state).forEach(k => delete state[k]);
    /* Remettre toutes les cartes à 0 visuellement */
    document.querySelectorAll('.pc-card').forEach(card => {
      card.classList.remove('is-selected', 'is-locked');
      card.querySelector('.pc-card__qty').textContent         = 0;
      card.querySelector('.pc-card__badge-qty').textContent   = 0;
      card.querySelector('.pc-card__btn--minus').disabled     = true;
      card.querySelector('.pc-card__btn--plus').disabled      = false;
    });
  }

  /* ── HELPERS COMPTAGE ─────────────────────────────────────── */
  function countCat (cat) {
    return Object.values(state).filter(v => v.category === cat).reduce((s, v) => s + v.qty, 0);
  }
  function countTotal () {
    return Object.values(state).reduce((s, v) => s + v.qty, 0);
  }
  function allComplete () {
    return currentProgram && ['pd', 'sale', 'encas'].every(c => countCat(c) >= quotas[c]);
  }
  function totalPriceFormatted () {
    const cents = Object.values(state).reduce((s, v) => s + v.price * v.qty, 0);
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  /* ── MISE À JOUR UI ───────────────────────────────────────── */
  function updateUI () {
    if (!currentProgram) return;

    const total     = countTotal();
    const maxTotal  = quotas.pd + quotas.sale + quotas.encas;
    const pct       = Math.min(100, Math.round(total / maxTotal * 100));
    const complete  = allComplete();

    /* Barre de progression globale */
    const fill = document.getElementById('pc-fill');
    if (fill) fill.style.width = pct + '%';

    const stickyFill = document.getElementById('sticky-fill');
    if (stickyFill) stickyFill.style.width = pct + '%';

    /* Compteur sticky */
    const sSel = document.getElementById('sticky-selected');
    if (sSel) sSel.textContent = total;

    /* Hint sticky */
    const hint = document.getElementById('sticky-hint');
    if (hint) hint.classList.toggle('is-hidden', complete);

    /* Prix total dans la sticky — affiché UNIQUEMENT si tout est complet */
    const priceEl = document.getElementById('sticky-price');
    if (priceEl) {
      if (complete) {
        document.getElementById('sticky-price-amount').textContent = totalPriceFormatted();
        priceEl.classList.add('is-visible');
      } else {
        priceEl.classList.remove('is-visible');
      }
    }

    /* CTA */
    const atc = document.getElementById('pc-add-to-cart');
    if (atc) atc.disabled = !complete;

    /* Par catégorie */
    ['pd', 'sale', 'encas'].forEach(cat => {
      const count = countCat(cat);
      const quota = quotas[cat];
      const done  = count >= quota;

      /* Compteurs */
      setText('c-' + cat, count);
      setText('count-' + cat, count);

      /* Pill bloc */
      const pill = document.getElementById('pill-' + cat);
      if (pill) pill.classList.toggle('is-complete', done);

      /* Cat progress */
      const prog = document.getElementById('prog-' + cat);
      if (prog) prog.classList.toggle('is-complete', done);

      /* Cartes */
      document.querySelectorAll(`.pc-card[data-category="${cat}"]`).forEach(card => {
        const vid = card.dataset.variantId;
        /* Ignorer les cartes en rupture (vid vide) pour éviter la sélection groupée */
        if (!vid || card.dataset.soldOut === 'true') return;
        const qty = state[vid]?.qty || 0;
        const sel = qty > 0;
        const locked = done && !sel;

        card.classList.toggle('is-selected', sel);
        card.classList.toggle('is-locked', locked);

        card.querySelector('.pc-card__qty').textContent       = qty;
        card.querySelector('.pc-card__badge-qty').textContent = qty;
        card.querySelector('.pc-card__btn--minus').disabled   = qty <= 0;
        card.querySelector('.pc-card__btn--plus').disabled    = done && !sel;
      });
    });
  }

  function setText (id, val) {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  }

  /* ── REFRESH COMPTEUR PANIER ──────────────────────────────── */
  function refreshCartCount () {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      ['.cart-link__bubble', '[data-cart-count]', '.cart-count', '.site-header__cart-count'].forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.textContent = cart.item_count;
          el.setAttribute('data-cart-count', cart.item_count);
        });
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    }).catch(() => {});
  }

  /* ── TOAST ────────────────────────────────────────────────── */
  let toastTimer;
  function showToast (msg, type) {
    const t = document.getElementById('plan-toast');
    if (!t) return;
    clearTimeout(toastTimer);
    t.textContent = msg;
    t.className   = `plan-toast${type === 'ok' ? ' is-ok' : type === 'err' ? ' is-err' : ''} show`;
    toastTimer = setTimeout(() => t.classList.remove('show'), 3500);
  }

})();